// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import DuesPage from './pages/DuesPage';
import LoginPage          from './pages/LoginPage';
import SetPasswordPage    from './pages/SetPasswordPage';
import DashboardPage      from './pages/DashboardPage';
import ProfilePage        from './pages/ProfilePage';
import UnauthorizedPage   from './pages/UnauthorizedPage';
import DirectoryPage from './pages/DirectoryPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import PaymentEntryPage from './pages/PaymentEntryPage';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import FundraisingPage from './pages/FundraisingPage';
import MemberManagementPage from './pages/MemberManagementPage';
import OpportunitiesPage from './pages/OpportunitiesPage';
import ActivitiesPage from './pages/ActivitiesPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login"        element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="/activities" element={
            <ProtectedRoute><ActivitiesPage /></ProtectedRoute>
          } />
          {/* First login only */}
          <Route path="/set-password" element={<SetPasswordPage />} />

          {/* Protected — all members */}
          <Route path="/dashboard" element={
            <ProtectedRoute><DashboardPage /></ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/profile/:memberId" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          {/* Placeholder routes — pages coming soon */}
          <Route path="/directory" element={
          <ProtectedRoute><DirectoryPage /></ProtectedRoute>
          }  />
          <Route path="/dues" element={
          <ProtectedRoute><DuesPage /></ProtectedRoute>
          } />
          <Route path="/announcements" element={
          <ProtectedRoute><AnnouncementsPage /></ProtectedRoute>
          } />
          <Route path="/opportunities" element={
            <ProtectedRoute><OpportunitiesPage /></ProtectedRoute>
          } />
          <Route path="/fundraising" element={
            <ProtectedRoute><FundraisingPage /></ProtectedRoute>
          } />
          <Route path="/payments/enter" element={
            <ProtectedRoute allowedRoles={['treasurer', 'executive']}>
              <PaymentEntryPage />
            </ProtectedRoute>
          } />
          <Route path="/exec-dashboard" element={
            <ProtectedRoute allowedRoles={['executive', 'treasurer']}>
              <ExecutiveDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/members" element={
            <ProtectedRoute allowedRoles={['executive']}>
              <MemberManagementPage />
            </ProtectedRoute>
          } />
          {/* Default */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

// Temporary placeholder for pages not yet built

export default App;